import State from '../ms-base/state'

export default { ...new State('app-modules') }
